<template>
  <v-container grid-list-xl>
    <v-layout wrap justify-space-between>
      <v-flex xs12 md12>
        <v-alert :value="alert" type="success">Başarıyla kaldedildi.</v-alert>
      </v-flex>
      <v-flex xs12 md12>
        <v-flex xs12 md12>
          <v-switch
              v-model="formulaMultiplier.isAllProduct"
              @change="changeAllProduct"
              :label="`Ürünlerin Hepsini Seç: ${setState(formulaMultiplier.isAllProduct)}`"
          ></v-switch>
        </v-flex>
      </v-flex>
      <v-flex xs12 md12>
        <v-combobox
            v-model="select"
            :items="this.$store.getters['products/productCategories']"
            item-value="id"
            multiple
            item-text="name"
            hide-details
            label="Ürün Seçiniz"
        ></v-combobox>
      </v-flex>
      <v-flex xs12 md12>
        <v-text-field v-model="formulaMultiplier.formula" label="Çarpan Değeri" :counter="max" required></v-text-field>
      </v-flex>
      <v-flex xs12 md12>
        <v-text-field v-model="formulaMultiplier.order" label="Çarpan Sırası" :counter="max" required></v-text-field>
      </v-flex>
      <v-flex xs12 md12>
        <v-switch v-model="formulaMultiplier.state" :label="`Aktif Mi:`"></v-switch>
      </v-flex>
      <v-btn color="success" @click="saveFormulaMultiplier">Kaydet</v-btn>
    </v-layout>
  </v-container>
</template>
<script>

export default {
  data: () => ({
    select: [],
    selectCategory: {},
    alert: false,
    // formulaMultiplier: {
    //   status: false
    // },
    allowSpaces: false,
    match: "Foobar",
    max: 0,
    model: "Foobar",
    formulaMultiplier: {
      state: true
    }
  }),

  watch: {},

  methods: {
    setState(state) {
      if (state) return "Aktif";
      return "Pasif";
    },
    changeAllProduct(categoryids) {
      if (categoryids) {
        this.select = this.$store.getters["products/productCategories"];
      } else {
        this.select = [];
      }
    },
    async saveFormulaMultiplier() {
      let formulaMultiplier = Object.assign({}, this.formulaMultiplier);
      formulaMultiplier.productIds = this.select.map((m) => m.id).join(",");
      if (this.formulaMultiplier.id) this.$store.dispatch("formulaMultipliers/putFormulaMultiplier", formulaMultiplier);
      else this.$store.dispatch("formulaMultipliers/postFormulaMultiplier", formulaMultiplier);
      this.alert = true;
    },
  },
  computed: {},
  async mounted() {
    await this.$store.dispatch("products/getProductsByMpProducts");
    
    if (this.$route.params.id) {
      await this.$store.dispatch("formulaMultipliers/getformulaMultipliers", this.$route.params.id);
      this.formulaMultiplier = this.$store.state.formulaMultipliers.formulaMultiplier;
      if (this.formulaMultiplier.productIds) {
        var ids = this.formulaMultiplier.productIds.split(",").map(Number);
        this.select = this.$store.getters["formulaMultiplier/productCategories"].filter(
            (x) => ids.includes(x.id)
        );
      }
    }
  },
  async created() {
  }
};
</script>